import React, { Component } from 'react';
import { Card, CardTitle, CardHeader, CardBody, Button } from 'reactstrap';

const Page = props => {
    return null;
}

export default Page;